import { useDispatch } from 'react-redux';
import { closeCustomDialogAction } from 'redux/slices/customDialogSlice';
import { addShortVideo } from 'redux/slices/shortVideoSlice';
import ShortVideoForm from './ShortVideoForm';

const ShortVideoCreate = ({ asset, onComplete, onCancel }) => {
    const dispatch = useDispatch();

    const data = {
        name: '',
        description: '',
    };

    const handleSubmit = (editedData, onSuccess, onFailure) => {
        editedData.products = editedData.products?.filter((id) => id) || [];
        dispatch(
            addShortVideo(
                editedData,
                (taskResult) => {
                    try {
                        onComplete?.(taskResult);
                    } catch (error) {
                        console.error(`Error calling short video create onComplete callback: ${error.message}`);
                    }
                    onSuccess(taskResult);
                    dispatch(closeCustomDialogAction());
                },
                (taskResult) => onFailure(taskResult),
            ),
        );
    };

    return <ShortVideoForm onSubmit={handleSubmit} data={data} asset={asset} onCancel={onCancel}/>;
};

export default ShortVideoCreate;
